// extracted by mini-css-extract-plugin
module.exports = {"Label":"input_Label__2eDoK","Input":"input_Input__1TXNC","Select":"input_Select__3AWpt","Message":"input_Message__37MBo","Multiline":"input_Multiline__2sQSv"};